/**
 * @generated SignedSource<<89864ae43f4f70b66a76924bb90a35a5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4ProjectsForLanding$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Nav4ProjectsContent">;
  readonly " $fragmentType": "Nav4ProjectsForLanding";
};
export type Nav4ProjectsForLanding$key = {
  readonly " $data"?: Nav4ProjectsForLanding$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4ProjectsForLanding">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentURL"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4ProjectsForLanding",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "currentURL",
          "variableName": "currentURL"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Nav4ProjectsContent"
    }
  ],
  "type": "Query"
};

(node as any).hash = "a133f4f2dee068a96d8b17f4cc9743e5";

export default node;
